import arrayTools from "_src/engine/utility/arrays";

export default function buildHalfEdge(indices, numVertices) {

  let startTime;

  if (typeof performance !== "undefined") {
    startTime = performance.now();
  }

  const UintArray = arrayTools.uintArrayTypeByMaxValue(indices.length, 3);

  const V2e = new UintArray( numVertices );
  const E2e = new UintArray( indices.length );
  const mask = new Int8Array( indices.length );

  const HalfEdgesMap = {};

  for (let j = 0; j < indices.length; ++j ) {

    const currentVertLocalInd = j % 3;

    const vIndCurr = indices[j];
    const vIndNext = currentVertLocalInd < 2 ? indices[j+1]: indices[j-2];

    if (!(vIndCurr in HalfEdgesMap)) {
      HalfEdgesMap[vIndCurr] = new Array(0);
    }

    HalfEdgesMap[vIndCurr].push(j);

    if (vIndNext in HalfEdgesMap) {

      const nextVHalfEdges = HalfEdgesMap[vIndNext];

      for (let i = 0; i < nextVHalfEdges.length; ++i) {

        const ind = nextVHalfEdges[i];

        const vIndCollCurr = indices[ind];
        const vIndCollNext = ind % 3 < 2 ? indices[ind + 1]
                                         : indices[ind - 2];

        if (vIndCollCurr === vIndNext && vIndCollNext === vIndCurr) {

          // collision with a twin half-edge

          E2e[j] = ind;
          E2e[ind] = j;

          mask[j] = 1;
          mask[ind] = 1;

          break;

        }

      }

    }

    V2e[vIndCurr] = j;

  }

  for (let j = 0; j < indices.length; ++j) {

    const hasTwin = mask[j] === 1;

    if (hasTwin) {
      continue;
    }

    const currentVertLocalInd = j % 3;
    const vIndNext = currentVertLocalInd < 2 ? indices[j+1]: indices[j-2];

    E2e[j] = j;
    V2e[vIndNext] = j;
    mask[j] = -1;

  }

  const messages = [];
  if (typeof performance !== "undefined") {
    messages.push("Half Edges: building time: " +
                      ((performance.now() - startTime) / 1000).toPrecision(3) + " sec.");
  }

  return {E2e, V2e, mask, indices, messages};

}
